import React from 'react';
import { useSelector } from 'react-redux';
import { DebouncedSearchField } from '../../../../commonComponents/DebouncedSearchField';
import { SelectFilter } from '../../../../commonComponents/filters/SelectFilter';
import { MultiStatePicker } from '../../../../commonComponents/MultiStatePicker';
import { jobStatusOptions } from '../../shared/constants';
import { userDaSubProfessions } from '../../../../../constants';
import { useGetPaymentPlans } from '../../../../../domain/PermanentJobs/useCases/useGetPaymentPlans';
import { useGetUsersByIds } from '../../../../../domain/Users';
import { RemoteConfigUtils } from '../../../../../utils/RemoteConfigUtils';

// This page's "All" is the empty string, not the `'all'` sentinel the older
// filter definitions use — so these go straight onto SelectFilter, which
// passes values through untouched, rather than through FilterSelect.
const ALL = '';

const withAll = (options) => [{ value: ALL, label: 'All' }, ...options];

/** The Permanent Jobs (v2) list's filter fields, for ListPage's `filters` card. */
export const Filters = ({ filters, handleFilterChanged }) => {
  const { data: paymentPlans } = useGetPaymentPlans();
  const { data: recruiters } = useGetUsersByIds(RemoteConfigUtils.getPermanentRecruiterIds());
  const allProfessions = useSelector((state) => state.jobs.allProfessions);

  return (
    <>
      <DebouncedSearchField
        label="Search"
        placeholder="Search by id or office name"
        value={filters?.searchText}
        onChange={(value) => handleFilterChanged('searchText', value)}
      />

      <SelectFilter
        label="Plan"
        options={withAll((paymentPlans || []).map((plan) => ({
          value: plan.id,
          label: plan.name,
        })))}
        value={filters?.plan || ALL}
        onChange={(plan) => handleFilterChanged('plan', plan)}
      />

      <SelectFilter
        label="Recruiter"
        options={withAll((recruiters || []).map((recruiter) => ({
          value: recruiter.id,
          label: recruiter.email,
        })))}
        value={filters?.recruiter || ALL}
        onChange={(recruiter) => handleFilterChanged('recruiter', recruiter)}
      />

      <SelectFilter
        label="Profession"
        options={withAll(
          [...(allProfessions || []), ...(userDaSubProfessions || [])].map(({ code, name }) => ({
            value: code,
            label: name,
          })),
        )}
        value={filters?.professionType || ALL}
        onChange={(professionType) => handleFilterChanged('professionType', professionType)}
      />

      <SelectFilter
        label="Status"
        options={withAll(jobStatusOptions.map(({ code, name }) => ({ value: code, label: name })))}
        value={filters?.status || ALL}
        onChange={(status) => handleFilterChanged('status', status)}
      />

      {/* Keeps MultiStatePicker rather than the shared StateFilter: this page's
          `states` filter clears to `undefined` and labels by abbreviation. */}
      <MultiStatePicker
        label="State"
        value={filters?.states}
        onChange={(value) => handleFilterChanged('states', value)}
      />
    </>
  );
};
